import request from '@/request'

export function getHomeImages(){
    return request({
        url:'/publicize/getList',
        method:'get',
    })
}
export function getCustomers(){
    return request({
        url:'/customers/getList',
        method:'get',
    })
}